import React from "react";
import { Pane } from "evergreen-ui";
import * as R from "ramda";

export const Pagination = ({ totalCount, perPage, page, setPage }) => {
  console.log({ totalCount, perPage, page, setPage });
  const numberOfPages = Math.round(totalCount / perPage);
  const shownPages = [
    1,
    2,
    3,
    page - 1,
    page,
    page + 1,
    numberOfPages - 1,
    numberOfPages
  ].filter(el => el > 0);
  const filteredPages = R.uniq(shownPages);
  const addedDots = R.reduce(
    (acc, value) => {
      const lastElement = R.last(acc);
      if (lastElement + 2 === value) acc.push(value - 1);
      if (lastElement + 2 < value) acc.push("...");
      return acc.concat(value);
    },
    [],
    filteredPages
  );
  return (
    <Pane>
      {addedDots.map(el =>
        Number.isInteger(el) ? (
          <Pane
            padding="8px"
            style={{ border: "1px solid black" }}
            display="inline-block"
            onClick={() => setPage(el)}
            background={page === el ? "black" : "transparent"}
          >
            {el}
          </Pane>
        ) : (
          <Pane display="inline-block">...</Pane>
        )
      )}
    </Pane>
  );
};
